









































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import { Mutation } from 'vuex-class';
import storage from 'baimahu/storage';
import { MUTATION_LOG_ON_OUT } from '@/store/type';
const md5 = require('blueimp-md5');
const LOGIN_TYPE = [
  { id: 1, name: '密码登录' },
  { id: 2, name: '验证码登录' },
];
const {VUE_APP_FCAPI: FCAPI, VUE_APP_EXPIRED: EXPIRED, VUE_APP_API} = process.env;

const API = {
  checkQyLogin: `${VUE_APP_API}/qy/passport/login/login-by-session`,
  password: `${FCAPI}/shang/ruan/passport/mobile`,
  captcha: `${FCAPI}/shang/setting/captcha`,
  login_merchant: `${FCAPI}/shang/ruan/passport/merchant`,
};
@Component
export default class Login2 extends Vue {
  @Mutation(MUTATION_LOG_ON_OUT) logOnOut: any;
  isLoading: boolean = false;
  loginType: any = LOGIN_TYPE;
  selectedIndex: number = 1;
  mobile: string = '';
  password: string = '';
  code: string = '';
  authCode: number = 60;
  validateText: string = '';

  changeLoginType(id: number) {
    this.selectedIndex = id;
  }

  async sendCaptch() {
    const res: AxiosResponse = await this.$axios.post(API.captcha, {
      mobile: this.mobile,
    });

    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      return;
    }

    const timer = setInterval(() => {
      this.authCode -= 1;
      if (this.authCode === 0) {
        clearInterval(timer);
        this.authCode = 60;
      }
    }, 1000);
  }

  updateInput(value: string) {
    if (value) {
      this.validateText = '';
    }
  }

  async login() {
    if (!this.mobile) {
      this.validateText = '请输入手机号';
      return;
    }
    if (!this.mobile || !/^1[0-9]{10}$/.test(String(this.mobile))) {
      this.validateText = '请输入正确的手机号';
      return;
    }
    if (this.selectedIndex === 1 && !this.password) {
      this.validateText = '请输入密码';
      return;
    }
    if (this.selectedIndex === 2 && !this.code) {
      this.validateText = '请输入验证码';
      return;
    }

    // 登陆 FCAPI
    let res_fcapi: AxiosResponse;
    if (this.selectedIndex === 1) {
      res_fcapi = await this.$axios.post(API.password, {
        mobile: this.mobile,
        password: md5(this.password),
      });
      storage.setItem('account_info', {
        mobile: this.mobile,
        password: md5(this.password),
      }, EXPIRED);
    } else {
      res_fcapi = await this.$axios.put(API.captcha + '/' + this.code, {
        mobile: this.mobile,
      });
    }

    const remote_fcapi = res_fcapi.data;
    console.log('remote_fcapi', remote_fcapi);
    if (remote_fcapi.status !== 200) {
      this.$message.error(remote_fcapi.message);
      return;
    }

    console.debug(remote_fcapi);
    // 同步登录状态
    // PROFILE 改为前端设置
    sessionStorage.setItem('merchant_type', '1');
    storage.setItem('merchant_list', remote_fcapi.data, EXPIRED);
    if (remote_fcapi.data.length > 1) {
      this.$router.push(`/select-merchant?mobile=${this.mobile}`);
    } else {
      const res = await this.$axios.post(API.login_merchant, {
        mobile: this.mobile,
        password: md5(this.password),
        merchant_id: remote_fcapi.data[0].merchant_id,
      });
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      remote_fcapi.data[0].activated_module = remote_fcapi.data[0].merchant.activated_module;
      remote_fcapi.data[0].package_type = 2;
      storage.setItem('profile', remote_fcapi.data[0], EXPIRED);
      await this.$axios.get(`${API.checkQyLogin}`);
      this.logOnOut(true);
      this.$router.push(`/`);
    }
  }

  // async mounted() {
  //   // 无论密码方式还是验证码登陆都需要新的 csrf-token
  //   await this.$axios.get(`${API.password}/new`);
  // }
}
